import { MdSend } from "react-icons/md";
import { Spinner } from "../../../componentes/Spinner";
import { IconButton, CircularProgress } from "@mui/material";
import { useRef, useState } from "react";
import { Collections } from "@mui/icons-material";
import useGallery from "../../../hooks/general/useGallery.jsx";

export function BlocoEnviar({ loading, msg, onChange, onSend, disabled, onFinishGallery, onErrorGallery }) {
	const textareaRef = useRef();
	const [openGallery, setOpenGallery] = useState(false);

	return (
		<div
			className="relative"
			style={{
				height: "5rem",
				display: "flex",
				alignItems: "center",
				borderRadius: "1rem",
				padding: "0.5rem",
				margin: "0.5rem",
				boxShadow: "0 0 15px -7px rgba(0,0,0,1)",
				position: "sticky",
				bottom: 0,
				zIndex: 1000,
				background: "white",
			}}
		>
			{loading && (
				<div className="absolute w-full h-full" style={{ zIndex: 1000 }}>
					<Spinner />
				</div>
			)}

			{/* Ícone da galeria — mesmo padrão: abrir "componente" que chama useGallery */}
			<IconButton
				aria-label="abrir galeria"
				disableRipple
				sx={{ p: 1, bgcolor: "transparent", "&:hover": { bgcolor: "transparent" } }}
				disabled={loading}
				onClick={() => setOpenGallery(true)}
			>
				<Collections />
			</IconButton>

			<textarea
				ref={textareaRef}
				value={msg}
				onChange={onChange}
				style={{
					resize: "none",
					background: "transparent",
					height: "100%",
					width: "calc(100% - 2.5rem)",
					lineHeight: 1,
					border: "none",
				}}
				disabled={loading}
			/>

			<div className="flex justify-center items-center">
				<IconButton
					onClick={() => {
						if (textareaRef.current) textareaRef.current.focus();
						onSend();
					}}
					disabled={disabled}
				>
					<MdSend />
				</IconButton>
			</div>

			{/* Monta o "ProtocolGallery" do chat: chama o hook e mostra loader */}
			{openGallery && (
				<ChatGallery
					onFinish={(URL) => {
						// URL vem do CDN (resp.dados do hook)
						if (typeof onFinishGallery === "function") onFinishGallery(URL);
						setOpenGallery(false);
					}}
					onError={(msg) => {
						if (typeof onErrorGallery === "function") onErrorGallery(msg);
						setOpenGallery(false);
					}}
				/>
			)}
		</div>
	);

	/** Igual ao ProtocolGallery:
   *  - Montou? Chama useGallery(onFinish, onError)
   *  - Mostra um spinner enquanto o hook resolve
   */
	function ChatGallery({ onFinish, onError }) {
		useGallery(onFinish, onError);
		return (
			<div className="text-center mt-3">
				<CircularProgress />
			</div>
		);
	}
}
